import { useServices } from 'core/services';
import { BaseHttpError } from 'core/services/api/errors';
import { WellWishesResponse } from 'core/services/api/response-types';
import { WellWish } from 'core/types';
import { getPageParams } from 'core/utils/pagination';
import { wellWishKeys } from 'core/utils/query-key-factory';
import { useInfiniteQuery, InfiniteData } from '@tanstack/react-query';

export const useGetWellWishes = (
	communityId: string,
	options: {
		enable?: boolean;
	} = {
		enable: true,
	}
) => {
	const { api, authentication } = useServices();

	const isLoggedIn = authentication.isAuthenticated();

	const wishesQuery = useInfiniteQuery<
		WellWishesResponse,
		BaseHttpError,
		InfiniteData<WellWish[]>
	>({
		queryKey: wellWishKeys.list(communityId),
		queryFn: ({ pageParam = undefined, signal }) => {
			return api.getWellWishes(communityId, {
				pagination: pageParam as any,
				signal,
			});
		},
		initialPageParam: undefined,
		enabled: !!communityId && isLoggedIn && options.enable,
		select: response => {
			return {
				pages: response.pages.map(page => page.data),
				pageParams: response.pageParams,
			};
		},
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
	});

	return wishesQuery;
};
